export default "__VITE_ASSET__D42MyeSQ__"